var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#FFFFFF",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2330 5110 c-494 -48 -950 -230 -1350 -538 -195 -150 -448 -432 -594 -662 -63 -99 -186 -351 -230 -471 -51 -139 -103 -344 -128 -504 -31 -200 -31 -550 0 -750 43 -273 114 -500 237 -750 132 -269 269 -460 489 -681 221 -220 412 -357 681 -489 247 -121 469 -192 745 -237 195 -31 565 -31 760 0 276 45 498 116 745 237 269 132 460 269 681 489 220 221 357 412 489 681 123 250 194 477 237 750 31 200 31 550 0 750 -43 273 -114 500 -237 750 -132 269 -269 460 -489 681 -221 220 -412 357 -681 489 -246 121 -474 193 -740 235 -147 23 -475 34 -615 20z m430 -351 c872 -79 1622 -675 1896 -1506 350 -1060 -145 -2212 -1156 -2691 -1014 -481 -2227 -116 -2825 848 -531 858 -396 1990 325 2710 465 465 1108 699 1760 639z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2270 3690 c-33 -16 -170 -146 -528 -503 -266 -265 -496 -502 -512 -526 -40 -60 -46 -101 -25 -159 15 -40 90 -120 504 -535 267 -269 506 -503 531 -520 117 -82 273 -1 272 143 -1 27 -8 61 -16 77 -8 15 -168 181 -355 368 l-341 340 992 5 c899 5 996 7 1023 22 64 35 97 90 97 158 0 68 -33 123 -97 158 -27 15 -124 17 -1023 22 l-992 5 341 340 c187 187 347 353 355 368 21 40 20 120 -3 158 -49 85 -141 117 -223 79z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.6e334c45e87d6f646b313751ebee65d6.svg";
export { ForwardRef as ReactComponent };